import { render, staticRenderFns } from "./TagColorList.vue?vue&type=template&id=4747cc30&scoped=true&"
import script from "./TagColorList.vue?vue&type=script&lang=ts&"
export * from "./TagColorList.vue?vue&type=script&lang=ts&"
import style0 from "./TagColorList.vue?vue&type=style&index=0&id=4747cc30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4747cc30",
  null
  
)

export default component.exports